var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsEnum, IsInt, IsObject, IsOptional, IsString, IsUUID, Max, Min, } from 'class-validator';
import { InvoiceFullSizeDto } from '../../invoice/index.js';
import { OfficeProductAssignmentFullSizeDto, OfficeProductFullSizeDto, } from '../../office-products/index.js';
import { OfficeLocationStub, } from '../../offices/index.js';
import { Role } from '../../roles/index.js';
import { StripeAccountStatus } from '../enum/stripe-account-status.enum.js';
import { TaxStatus } from '../enum/tax-status.enum.js';
import { PaymentFullSizeDto } from '../payment.full-size.dto.js';
import { ConnectedStripeCustomerPatientFullSizeDto } from './connected-stripe-customer-patient.full-size.dto.js';
export class ConnectedStripeAccountFullSizeDto {
    id;
    createdAt;
    updatedAt;
    officeLocations;
    payments;
    /**
     * List of {@link OfficeProductFullSizeDto}s that are assigned to this connected account.
     */
    officeProducts;
    /**
     * List of {@link InvoiceFullSizeDto}s that are assigned to this connected account.
     */
    invoices;
    stripeAccountId;
    idVerified;
    officeId;
    office;
    status;
    name;
    demoProductsCreated;
    taxStatus;
    stripeTaxRateId;
    stripeTaxId;
    applicationFeePercentage;
    connectedStripeCustomers;
    officeProductAssignments;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], ConnectedStripeAccountFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], ConnectedStripeAccountFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], ConnectedStripeAccountFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsArray(),
    Type(() => OfficeLocationStub),
    Expose(),
    __metadata("design:type", Array)
], ConnectedStripeAccountFullSizeDto.prototype, "officeLocations", void 0);
__decorate([
    IsArray(),
    Type(() => PaymentFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], ConnectedStripeAccountFullSizeDto.prototype, "payments", void 0);
__decorate([
    IsArray(),
    Type(() => OfficeProductFullSizeDto),
    __metadata("design:type", Array)
], ConnectedStripeAccountFullSizeDto.prototype, "officeProducts", void 0);
__decorate([
    IsArray(),
    Type(() => InvoiceFullSizeDto),
    __metadata("design:type", Array)
], ConnectedStripeAccountFullSizeDto.prototype, "invoices", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], ConnectedStripeAccountFullSizeDto.prototype, "stripeAccountId", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ConnectedStripeAccountFullSizeDto.prototype, "idVerified", void 0);
__decorate([
    IsUUID(),
    Expose({ groups: [Role.ADMIN, Role.MANAGEMENT, Role.SUPERADMIN] }),
    __metadata("design:type", String)
], ConnectedStripeAccountFullSizeDto.prototype, "officeId", void 0);
__decorate([
    IsObject(),
    Exclude(),
    __metadata("design:type", Function)
], ConnectedStripeAccountFullSizeDto.prototype, "office", void 0);
__decorate([
    Expose(),
    IsEnum(StripeAccountStatus),
    __metadata("design:type", String)
], ConnectedStripeAccountFullSizeDto.prototype, "status", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], ConnectedStripeAccountFullSizeDto.prototype, "name", void 0);
__decorate([
    IsBoolean(),
    Exclude(),
    __metadata("design:type", Boolean)
], ConnectedStripeAccountFullSizeDto.prototype, "demoProductsCreated", void 0);
__decorate([
    Expose(),
    IsEnum(TaxStatus),
    IsOptional(),
    __metadata("design:type", Object)
], ConnectedStripeAccountFullSizeDto.prototype, "taxStatus", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], ConnectedStripeAccountFullSizeDto.prototype, "stripeTaxRateId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Exclude(),
    __metadata("design:type", Object)
], ConnectedStripeAccountFullSizeDto.prototype, "stripeTaxId", void 0);
__decorate([
    IsInt(),
    Min(0),
    Max(100),
    Expose(),
    __metadata("design:type", Number)
], ConnectedStripeAccountFullSizeDto.prototype, "applicationFeePercentage", void 0);
__decorate([
    IsArray(),
    Type(() => ConnectedStripeCustomerPatientFullSizeDto),
    __metadata("design:type", Array)
], ConnectedStripeAccountFullSizeDto.prototype, "connectedStripeCustomers", void 0);
__decorate([
    IsArray(),
    Type(() => OfficeProductAssignmentFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], ConnectedStripeAccountFullSizeDto.prototype, "officeProductAssignments", void 0);
//# sourceMappingURL=connected-stripe-account.full-size.dto.js.map